<template>
<div class="tobeSentCommissionView bgc">
    <div class="filters">
        <div class="add">
            <el-button type="success" @click="handleConfirm">发放</el-button>
        </div>
        <div class="search">
            <el-input v-model="param.headername" placeholder="请输入团长名称" class="condition" clearable></el-input>
            <el-select v-model="param.brokeragetype" placeholder="凭证类型" class="condition" clearable>
                <el-option v-for="item in brokeragetypeList" :key="item.code" :label="item.name"
                           :value="item.code"></el-option>
            </el-select>
            <el-button type="primary" plain @click="handleQuery">搜索</el-button>
        </div>
    </div>
    <div class="result-list btn-operate-list">
        <el-table :data="tableData" style="width: 100%" ref="multipleTable"
                  @select="handleSelectionChange" @select-all="handleAllSelectionChange" @row-click="handleRowChange">
            <el-table-column type="selection" width="60" class-name="center" label-class-name="center" :selectable="selectable"></el-table-column>
            <el-table-column prop="brokeragetypename" label="佣金类型" class-name="title"></el-table-column>
            <el-table-column prop="subject" label="发放对象" min-width="250px" class-name="center">
                <template slot-scope="scope">
                    <div class="imageText">
                        <img class="img" v-lazy="scope.row.headerlogourl" :alt="scope.row.headerhostname"
                             preview="LeaderList">
                        <span>{{scope.row.headerhostname}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="productbrokerage" label="商品佣金（元）" class-name="center" min-width="100px">
                <template slot-scope="scope">￥{{scope.row.productbrokerage}}</template>
            </el-table-column>
            <el-table-column prop="headerbrokerage" label="团长佣金（元）" class-name="center" min-width="100px">
                <template slot-scope="scope">￥{{scope.row.headerbrokerage}}</template>
            </el-table-column>
            <el-table-column prop="totalbrokerage" label="佣金合计（元）" class-name="center" min-width="100px">
                <template slot-scope="scope">￥{{scope.row.totalbrokerage}}</template>
            </el-table-column>
            <el-table-column prop="ispay" label="可发状态" class-name="tr" label-class-name="tr">
                <template slot-scope="scope">
                    <div :class="scope.row.ispay?'tc-blue tr':'tc-orange tr'">{{scope.row.ispay?'可发':'暂不可发'}}</div>
                </template>
            </el-table-column>
        </el-table>
        <div class="brokerage">
            <div>此页共<span class="tc-red">{{this.tableData.length}}</span>条数据，</div>
            <div>已选<span class="tc-red">{{this.item.selectedList.length}}</span>笔</div>
            <div>共<span class="tc-red">￥{{(this.item.saleprice+this.item.recomprice).toFixed(2)}}</span></div>
            <div>（销售佣金<span class="tc-red">￥{{(this.item.saleprice).toFixed(2)}}</span></div>
            <div>推荐佣金<span class="tc-red">￥{{(this.item.recomprice).toFixed(2)}}</span>）</div>
        </div>
        <el-pagination background @current-change="_getList" :current-page.sync="page.page"
                       :page-size="page.pageSize"
                       :pager-count="11" layout="prev, pager, next" :total="total">
        </el-pagination>
    </div>
</div>
</template>

<script>
import {getPayBrokerageListByEvent, uploadEventBrokerageByBrand} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import {brandBusiness} from 'api/enumCode'
export default {
    name: 'tobeSentCommissionView',
    data() {
        return {
            param: {
                brokeragetype: '',
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                headername: '',
            },
            brokeragetypeList: brandBusiness.brokeragetype,
            page: {
                page: 1,
                pageSize: 10
            },
            tableData: [],
            total: 0,
            item: {
                selectedList: [],
                saleprice: 0,
                recomprice: 0
            }

        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        selectable(row, index) {
                return !!row.ispay
        },
        handleConfirm() {
            if (!this.item.selectedList.length) {
                this.$message.error('请选择需要发放的佣金')
                return false
            }
            this.$confirm(`确认发放${this.item.selectedList.length}笔佣金`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                let [recomidlist, saleidlist] = [[], []]
                this.item.selectedList.forEach(obj => {
                    if (obj.brokeragetype === 1) {
                        saleidlist.push(obj.brokerageid )
                    } else {
                        recomidlist.push(obj.brokerageid )
                    }
                })
                let obj = {
                    eventid: this.param.eventid,
                    recomidlist: recomidlist.join(','), // 推荐佣金
                    saleidlist: saleidlist.join(',') // 销售佣金
                }
                this._uploadEventBrokerageByBrand(obj)
            })
        },
        handleQuery() {
            this.page.page = 1
            this._getList()
        },
        handleSelectionChange(selection, row) {
            this.item.selectedList = selection
            this.item.saleprice = 0
            this.item.recomprice = 0
            this.item.selectedList.forEach(obj => {
                if (obj.brokeragetype === 1) {
                    obj.totalbrokerage = obj.totalbrokerage ? parseFloat(obj.totalbrokerage) : 0
                    this.item.saleprice += obj.totalbrokerage
                } else {
                    obj.totalbrokerage = obj.totalbrokerage ? parseFloat(obj.totalbrokerage) : 0
                    this.item.recomprice += obj.totalbrokerage
                }
            })
        },
        handleAllSelectionChange(selection) {
            this.handleSelectionChange(selection)
        },
        handleRowChange(row, column, event) {
            if (!row.ispay) return false
            let flag = false
            this.item.selectedList.forEach((obj, i) => {
                if (row.voucherid == obj.voucherid) {
                    this.$refs.multipleTable.toggleRowSelection(row, false)
                    this.item.selectedList.splice(i, 1)
                    flag = true
                }
            })
            if (!flag) {
                this.$refs.multipleTable.toggleRowSelection(row)
                this.item.selectedList.push(row)
            }
            this.handleSelectionChange(this.item.selectedList)
        },
        _uploadEventBrokerageByBrand(obj) {
            this.setLoading(true)
            uploadEventBrokerageByBrand({
                data: Object.assign({}, obj),
                success: data => {
                    this.setLoading(false)
                    this.$alert('<div class="tc-black">成功：<span class="tc-green">'+ data.data.succcount+'</span> 条</div><div>失败：<span class="tc-red">'+ data.data.failcount+'</span> 条</div>',
                        '发放结果', {
                        dangerouslyUseHTMLString: true
                    })
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getPayBrokerageListByEvent({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.handleSelectionChange([])
                    this.tableData = data.data.datalist
                    this.total = data.data.pageinfo.rowcount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.tobeSentCommissionView {
    padding: 20px;
    .brokerage{
        background: #fff;
        height: 80px;
        align-items: center;
        display: flex;
        padding: 0 20px;
    }
    .imageText{
        display: flex;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
